export const EVENT_KEY = 'event confirmation'
export const PROFILE_USER = 'profile user'
export const VENUES_ALL = 'all venues country city'
export const DASHBOARD_PEOPLE = 'list dashboard people'
export const CHATS = 'list chats'
export const SEND_CHAT = 'send chat'
export const SEND_CHAT_ACTION = 'send chat change action'
export const DASHBOARD_SESSIONS = 'list dashboard sessions'
export const DASHBOARD_POLLING = 'list dashboard polling survey questions'